import "../../../assets/css/skeletons.css";
import IAAvatarBlock from "../../../components/Molecules/IAAvatarBlock";
import Image from "../../../components/Atoms/Image";
import AiraFlag from "../../../assets/img/logo-mjv-aira-star.svg"

const FirstMessageSkeleton = () => {
  return (
    <div className="d-flex flex-row justify-content-start mb-4">
      <div className="d-flex justify-content-center align-items-top">
        <IAAvatarBlock className="d-flex justify-content-center align-items-center">
          <Image src={AiraFlag} alt="AiRA Flag" width="20" height="20" />
        </IAAvatarBlock>
      </div>
      <div className="skeleton-text ml-3 p-4 w-100"> {/* Adicione uma margem para distanciar do avatar */}
        <div className="skeleton skeleton-line" style={{ width: "100%", height: "20px", marginBottom: "10px" }}></div>
        <div className="skeleton skeleton-line" style={{ width: "80%", height: "20px", marginBottom: "10px" }}></div>
      </div>
    </div>
  );
};

export default FirstMessageSkeleton;
